import axios from 'axios';
import { APIOverrides } from '../../ApiOverrides';
import type { NotificationGroupMemberProps, NotificationGroupProps, PlayerNotificationProps, PublicPlayerProps } from '../../types';

let AUTH_SVC_API = '';

export interface CreateNotificationProps {
    player_id?: string;
    player_ids?: string[];
    title: string;
    message: string;
    notification_type: 'info' | 'success' | 'warning' | 'error' | 'promo';
    action_url?: string;
    image_url?: string;
    metadata?: Record<string, any>;
}

export const NotificationHelpers = {
    app_paths: [
        // Account Routes
        { label: 'Account Home', path_name: '/account', params: {}, requiredParams: [] as string[], primary: false },
        { label: 'Account Analytics', path_name: '/account/analytics', params: {}, requiredParams: [], primary: false },
        { label: 'Account Discord', path_name: '/account/discord', params: {}, requiredParams: [], primary: false },
        { label: 'Account Funds', path_name: '/account/funds', params: {}, requiredParams: [], primary: false },
        { label: 'Account Notifications', path_name: '/account/notifications', params: {}, requiredParams: [], primary: false },
        { label: 'Account Premium', path_name: '/account/premium', params: {}, requiredParams: [], primary: false },
        { label: 'Account Rebates', path_name: '/account/rebates', params: {}, requiredParams: [], primary: false },
        { label: 'Account Refer', path_name: '/account/refer', params: {}, requiredParams: [], primary: false },
        { label: 'Account Verify', path_name: '/account/verify', params: {}, requiredParams: [], primary: false },
        { label: 'Account Orders', path_name: '/account/orders/[contest_id]', params: { contest_id: '' }, requiredParams: ['contest_id'], primary: false },
        { label: 'Account Rebate', path_name: '/account/rebate/[rebate_id]', params: { rebate_id: '' }, requiredParams: ['rebate_id'], primary: false },

        // Competition Routes - PRIMARY
        { label: 'Competitions Home', path_name: '/competitions', params: {}, requiredParams: [], primary: false },
        { label: 'Bracket Competition', path_name: '/competitions/bracket/[bracket_competition_id]', params: { bracket_competition_id: '', mode: '' }, requiredParams: ['bracket_competition_id'], primary: true },
        { label: 'Competition', path_name: '/competitions/competition/[competition_id]', params: { competition_id: '' }, requiredParams: ['competition_id'], primary: true },
        { label: 'Season', path_name: '/competitions/season/[season_id]', params: { season_id: '' }, requiredParams: ['season_id'], primary: false },
        { label: 'Squares Competition', path_name: '/competitions/squares/[sq_comp_id]', params: { sq_comp_id: '' }, requiredParams: ['sq_comp_id'], primary: true },
        { label: 'Trivia', path_name: '/competitions/trivia/[trivia_id]', params: { trivia_id: '' }, requiredParams: ['trivia_id'], primary: false },

        // Market Routes - PRIMARY
        { label: 'Markets Home', path_name: '/markets', params: {}, requiredParams: [], primary: false },
        { label: 'Favorites', path_name: '/markets/favorites', params: {}, requiredParams: [], primary: false },
        { label: 'Filters', path_name: '/markets/filters', params: {}, requiredParams: [], primary: false },
        { label: 'Live Markets', path_name: '/markets/live', params: {}, requiredParams: [], primary: false },
        { label: 'Parlays', path_name: '/markets/parlays', params: {}, requiredParams: [], primary: false },
        { label: 'Market Activity', path_name: '/markets/activity/[content_id]', params: { content_id: '' }, requiredParams: ['content_id'], primary: false },
        { label: 'Contest', path_name: '/markets/contest/[contest_id]', params: { contest_id: '', contest_type: '' }, requiredParams: ['contest_id', 'contest_type'], primary: true },
        { label: 'Filter', path_name: '/markets/filter/[player_filter_id]', params: { player_filter_id: '', mode: '' }, requiredParams: ['player_filter_id'], primary: false },
        { label: 'Fund', path_name: '/markets/fund/[fund_id]', params: { fund_id: '' }, requiredParams: ['fund_id'], primary: false },
        { label: 'Hedge', path_name: '/markets/hedge/[hedge_id]', params: { hedge_id: '' }, requiredParams: ['hedge_id'], primary: false },
        { label: 'Hedges', path_name: '/markets/hedges/[contest_id]', params: { contest_id: '' }, requiredParams: ['contest_id'], primary: false },
        { label: 'League', path_name: '/markets/league/[league_id]', params: { league_id: '' }, requiredParams: ['league_id'], primary: false },
        { label: 'Market', path_name: '/markets/market/[contest_id]', params: { contest_id: '', contest_type: '', market_id: '', side_type: '', side_id: '' }, requiredParams: ['contest_id', 'contest_type', 'market_id'], primary: true },
        { label: 'Team', path_name: '/markets/team/[team_id]', params: { team_id: '' }, requiredParams: ['team_id'], primary: false },

        // Partner Routes
        { label: 'Partner Home', path_name: '/partner', params: {}, requiredParams: [], primary: false },
        { label: 'BettorBot', path_name: '/partner/bettorbot', params: {}, requiredParams: [], primary: false },
        { label: 'Flash Campaign', path_name: '/partner/flash/[flash_campaign_id]', params: { flash_campaign_id: '' }, requiredParams: ['flash_campaign_id'], primary: false },

        // Social Routes
        { label: 'Social Home', path_name: '/social', params: {}, requiredParams: [], primary: false },
        { label: 'Contacts', path_name: '/social/contacts', params: {}, requiredParams: [], primary: false },
        { label: 'Feed', path_name: '/social/feed', params: {}, requiredParams: [], primary: false },
        { label: 'Groups', path_name: '/social/groups', params: {}, requiredParams: [], primary: false },
        { label: 'Leaders', path_name: '/social/leaders', params: {}, requiredParams: [], primary: false },
        { label: 'Players', path_name: '/social/players', params: {}, requiredParams: [], primary: false },
        { label: 'Post Activity', path_name: '/social/activity/[post_id]', params: { post_id: '' }, requiredParams: ['post_id'], primary: false },
        { label: 'Campaign', path_name: '/social/campaign/[campaign_id]', params: { campaign_id: '' }, requiredParams: ['campaign_id'], primary: false },
        { label: 'Chat', path_name: '/social/chat/[player_id]', params: { player_id: '' }, requiredParams: ['player_id'], primary: false },
        { label: 'Company', path_name: '/social/company/[company_id]', params: { company_id: '' }, requiredParams: ['company_id'], primary: false },
        { label: 'Group', path_name: '/social/group/[group_id]', params: { group_id: '' }, requiredParams: ['group_id'], primary: false },
        { label: 'Head to Head', path_name: '/social/h2h/[player_id]', params: { player_id: '' }, requiredParams: ['player_id'], primary: false },
        { label: 'Order', path_name: '/social/order/[order_id]', params: { order_id: '' }, requiredParams: ['order_id'], primary: false },
        { label: 'Player Profile', path_name: '/social/player/[player_id]', params: { player_id: '' }, requiredParams: ['player_id'], primary: false },
        { label: 'Podcast', path_name: '/social/podcast/[podcast_id]', params: { podcast_id: '' }, requiredParams: ['podcast_id'], primary: false },
        { label: 'Share', path_name: '/social/share/[content_id]', params: { content_id: '' }, requiredParams: ['content_id'], primary: false },

        // Custom
        { label: 'Custom Path', path_name: 'custom', params: {}, requiredParams: [], primary: false }
    ]
};

export const NotificationApi = {
    setEnvironment: () => {
        const endpoints = APIOverrides.getEndpoints();
        AUTH_SVC_API = endpoints['AUTH_SVC_API'] as string;
    },

    /**
     * Get players by player IDs
     */
    getPlayersByPlayerIds: async(player_ids: string[]): Promise<PublicPlayerProps[]> => {
        try {
            if(player_ids.length === 0) { return [] }
            const resp = await axios.post(`${AUTH_SVC_API}/v1/players/bulk/get`, { player_ids });
            return resp.data.players;
        } catch (e) {
            console.log('Error fetching players:', e);
            return [];
        }
    },

    /**
     * Send notifications to multiple players
     */
    broadcastNotifications: async(player_notification: PlayerNotificationProps, player_ids: string[]): Promise<{ message: string }> => {
        try {
            const resp = await axios.post(`${AUTH_SVC_API}/v1/notifications/bulk/send`, { player_notification, player_ids });
            console.log(resp.data)
            return resp.data;
        } catch (e) {
            console.log('Error broadcasting notifications:', e);
            throw e;
        }
    },
    getActiveNotificationGroups: async():Promise<NotificationGroupProps[]> => {
        try {
            const resp = await axios.get(`${AUTH_SVC_API}/v1/notifications/groups/active`);
            return resp.data.notification_groups
        } catch (e) {
            return []
        }
    },
    getNotificationGroupMembersByGroup: async(notification_group_id:string):Promise<NotificationGroupMemberProps[]> => {
        try {
            const resp = await axios.get(`${AUTH_SVC_API}/v1/notifications/group/members/${notification_group_id}`);
            return resp.data.notification_group_members
        } catch (e) {
            return []
        }
    }
}